import React, {useState} from "react";

// Chakra imports
import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Input,
    useColorModeValue,
    Text, useToast,
} from "@chakra-ui/react";
import {getAuth, sendPasswordResetEmail} from "firebase/auth";
import {useHistory} from "react-router-dom";


// Custom components
import CenteredAuth from "layouts/auth/types/Centered";

function ForgotPassword() {
    // Chakra color mode
    const [email, setEmail] = useState("")
    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";
    const brandStars = useColorModeValue("brand.500", "brand.400");
    const toast = useToast();
    const history = useHistory()

    function handleSubmit() {
        const auth = getAuth();
        sendPasswordResetEmail(auth, email)
            .then(() => {
                toast({
                    title: 'Password reset email sent. Please check your mailbox for details.',
                    status: 'info', 'isClosable': true,
                    duration: 4000
                })
                history.push('/auth/login/')
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.error("Error sending password reset email. errorCode =",
                    errorCode, "errorMessage", errorMessage);
                toast({
                    title: `Error resetting the password.\nError message ${errorMessage}`,
                    status: 'error', 'isClosable': true,
                    duration: 4000
                })
            });
    }

    return (
        <CenteredAuth
            // image={"linear-gradient(135deg, #868CFF 0%, #4318FF 100%)"}
            // cardTop={{base: "140px", md: "24vh"}}
            // cardBottom={{base: "50px", lg: "auto"}}
            >
            <Flex
                w='100%'
                maxW='max-content'
                me='auto'
                h='100%'
                alignItems='start'
                justifyContent='center'
                px={{base: "25px", md: "0px"}}
                flexDirection='column'>
                <Box mb='40px'>
                    <Heading
                        color={textColor}
                        fontSize={{base: "3xl", md: "36px"}}
                        mb='10px'>
                        Password reset
                    </Heading>
                    <Text maxW={'400px'} fontSize={'lg'}>
                        Please enter your email to receive a password reset link.
                    </Text>
                </Box>
                <Flex
                    zIndex='2'
                    direction='column'
                    w={{base: "100%", lg: "400px"}}
                    maxW='100%'
                    background='transparent'
                    borderRadius='10px'
                    mx={{base: "auto", lg: "unset"}}
                    me='auto'
                    mb={{base: "20px", md: "auto"}}
                    align='start'>
                    <FormControl>
                        <FormLabel
                            display='flex'
                            mb={'0px'}
                            fontWeight='500'
                            color={textColor}
                            >
                            Email
                        </FormLabel>
                        <Input
                            isRequired={true}
                            variant='auth'
                            type='email'
                            placeholder='mail@example.com'
                            borderRadius='10px'
                            mb='24px'
                            size='lg'
                            onChange={event => setEmail(event.currentTarget.value)}
                        />
                        <Button
                            variant='brand'
                            fontWeight='500'
                            borderRadius='10px'
                            w='100%'
                            h='50'
                            mt='30px'
                            onClick={handleSubmit}>
                            Email link
                        </Button>
                    </FormControl>
                </Flex>
            </Flex>
        </CenteredAuth>
    );
}

export default ForgotPassword;
